/**
 * Copyright ©2025 Drivepoint
 */

import Toast from "@services/Toast";

export default class Reload {

  static handleReloadReason(): void {
    let reason: any = sessionStorage.getItem("reload-reason");
    if (reason) {
      sessionStorage.removeItem("reload-reason");
      try {
        reason = JSON.parse(reason);
        switch (reason.type) {
          case "link": return Reload._onLink(reason);
          case "unlink": return Reload._onUnLink(reason);
        }
      } catch (error: any) {
        logger.error(error, reason);
      }
    }
  }

  private static _onLink(reason: any): void {
    const provider = Reload._getProviderById(reason.providerId);
    if (provider) {
      Toast.success(`Successfully linked your ${provider} account`);
    }
  }

  private static _onUnLink(reason: any): void {
    const provider = Reload._getProviderById(reason.providerId);
    if (provider) {
      Toast.success(`Successfully unlinked your ${provider} account`);
    }
  }

  private static _getProviderById(providerId: string): string | undefined {
    switch (providerId) {
      case "microsoft.com": return "Microsoft";
      case "google.com": return "Google";
      case "password": return "Email";
    }
  }

}
